import {
  assign, endpoint, options, check, convert,
} from '../helpers';
import { User } from '../../tools';

/**
 * According to the configuration,
 * the output is given as a file in different formats.
 *
 * @function
 * @param {Object} properties All parameters to be used in the function
 */

const download = (properties) => {
  const props = assign(properties);
  const model = {
    File: props.data.file,
    Query: props.data.query,
    Report: props.data.report,
  };

  fetch(endpoint('/report'), options(model))
    .then(response => response.json())
    .then((response) => {
      check(response.Token);
      if (response.Success) {
        const { outerWidth } = window;
        const path = endpoint(`/${User.getToken()}/downloadfile/${response.Data}`, 'media');

        if (outerWidth < 768) {
          const a = document.createElement('a');
          a.href = path;
          const evt = document.createEvent('MouseEvents');
          evt.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, true, false, false, false, 0, null);
          a.dispatchEvent(evt);
        } else {
          window.open(path);
        }

        props.success(convert(response.Message));
      } else {
        props.error(convert(response.Message));
      }
    })
    .catch(output => window.console.warn(output));
};

export default download;
